import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Pricing } from './components/Pricing';
import { ClosingCTA } from './components/ClosingCTA';
import { Clients } from './components/Clients';
import { HostingBanner } from './components/HostingBanner';
import { WhyUs } from './components/WhyUs';
import { WebPlans } from './components/WebPlans';
import { Blog } from './components/Blog';
import { Footer } from './components/Footer';

// Section order mirrors the live studiowebvip.com home page
export function App() {
  return <div className="min-h-screen w-full bg-[#141414]" data-id="element-0" data-mp="31bs2licab5ot">
      <Header data-id="element-1" data-mp="31cjpm4rtfv3h" />
      <main data-id="element-2" data-mp="2wk9zooqpav17">
        <Hero data-id="element-3" data-mp="2wjgu3r3habkn" />
        <About data-id="element-4" data-mp="2wiyvintcfl9k" />
        <Pricing data-id="element-5" data-mp="2wifgbev2vaz8" />
        <ClosingCTA data-id="element-6" data-mp="2whxb3sqftmf6" />
        <Clients data-id="element-7" data-mp="28ufoebm15ej2" />
        <HostingBanner data-id="element-8" data-mp="28tw3qn4zwc1c" />
        <WhyUs data-id="element-9" data-mp="28t4lsf4bmctj" />
        <WebPlans data-id="element-10" data-mp="28sl3gxardmez" />
        <Blog data-id="element-11" data-mp="28s2x37udtrtc" />
      </main>
      <Footer data-id="element-12" data-mp="23vuokdaowwv5" />
    </div>;
}